import React from 'react';
import './header.styles.scss';

const Header = () => {
  return (
    <div className='header header-title'>
      <h1>NASA Photo of the day</h1>
    </div>
  );
};

export default Header;
